import React, { useEffect, useState } from 'react'
import { Sidebar } from '../components/Layout/Sidebar'
import Topbar from '../components/Layout/Topbar'
import { Toaster } from 'react-hot-toast'
import DeliveryBoyData from '../components/DeliveryBoyDataLists/DeliveryBoyData'
import { supabase } from '../supabase.config'
import { useSelector } from 'react-redux'
import { syncAllDeliveryAssignmentStatuses } from '../utils/deliveryAssignmentService'

const DeliveryBoyDataList = () => {
	const [activeTab, setActiveTab] = useState("all")
	const [deliverytData, setDeliverytData] = useState([])
	const [searchOrderNo, setSearchOrderNo] = useState("")
	const { isAuthenticated, users, userProfile } = useSelector(
		(state) => state.user
	)
    const fetchDeliveryBoyDataList = async () => {
        try {
            let rows = await syncAllDeliveryAssignmentStatuses()
            if (activeTab === 'currentday') {
                const today = new Date(); today.setHours(0,0,0,0)
                rows = rows.filter(r => { const d = r.created_at ? new Date(r.created_at) : null; if (d) d.setHours(0,0,0,0); return d && d.getTime() === today.getTime() })
            }
            // Map to UI shape expected by DBoyList (compat with Firestore fields)
            const mapped = rows.map(r => ({
                id: r.id,
                user: r.assigned_user || r.user || {},
                createdAt: r.created_at ? { toDate: () => new Date(r.created_at) } : { toDate: () => new Date() },
                lrNumber: r.lr_numbers || [],
                vehicleNo: r.vehicle_no || '',
                deliveryBoyStatus: r.delivery_boy_status || r.status || ''
            }))
            setDeliverytData(mapped)
        } catch (e) {
            console.error('Failed to fetch delivery boy data list', e)
            setDeliverytData([])
        }
    }

	console.log(deliverytData)

    const deleteOrder = async (id) => {
        try {
            const { error } = await supabase.from('delivery_boy_data').delete().eq('id', id)
            if (error) throw error
            setDeliverytData(prev => prev.filter(x => x.id !== id))
        } catch (e) {
            alert('Failed to delete: ' + e.message)
        }
    }

	useEffect(() => {
		fetchDeliveryBoyDataList()
	}, [activeTab])

	const filteredDeliveryData = deliverytData.filter((item) => {
		if (!searchOrderNo.trim()) return true
		const query = searchOrderNo.trim().toLowerCase()
		return (item?.lrNumber || []).some((orderNo) => String(orderNo).toLowerCase().includes(query))
	})


	return (
		<div className='flex bg-slate-100/80'>
			<Toaster />
			<Sidebar />
			<div className='flex h-[100vh] flex-1 flex-col overflow-y-scroll' >
				<Topbar />
				<DeliveryBoyData
					deleteOrder={deleteOrder}
					deliverytData={filteredDeliveryData}
					totalDeliveryData={deliverytData}
					activeTab={activeTab}
					setActiveTab={setActiveTab}
					searchOrderNo={searchOrderNo}
					setSearchOrderNo={setSearchOrderNo}
				/>
			</div>
		</div>
	)
}

export default DeliveryBoyDataList
